import React from "react";

const Select = ({
  name,
  label,
  placeholder,
  value,
  options = [],
  error,
  onChange,
  listKey,
  listName,
  ...rest
}) => {
  return (
    <div className="form-group">
      {label && <label htmlFor={name}>{label}</label>}
      <select
        className="form-control"
        value={value}
        onChange={onChange}
        name={name}
        id={name}
        {...rest}
      >
        <option disabled value="">
          {placeholder}
        </option>
        {options.map((option) => (
          <option key={option[listKey]} value={option[listKey]}>
            {option[listName]}
          </option>
        ))}
      </select>
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

Select.defaultProps = {
  listKey: "id",
  listName: "name",
};

export default Select;
